import { connect } from 'react-redux';
import { compose, withHandlers, withState } from 'recompose';

import { setCustomTip } from '../actions';

export default compose(
  connect(null, { setCustomTip }),
  withState('tip', 'setTip', 0),
  withHandlers({
    onChange: props => value => props.setTip(value),
    onSubmit: props => (e) => {
      e.preventDefault();
      props.setCustomTip(props.tip);
      props.close();
    },
    increment: props => () => props.setTip(props.tip + 100),
    decrement: props => () => {
      const nextTip = props.tip - 100;
      if (nextTip < 0) {
        props.setTip(0);
        return;
      }

      props.setTip(nextTip);
    },
  }),
);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/CustomTipSharedContainer.js